export const fontFamily = ["Inter", "Roboto", "sans-serif"].join(",");
